import ArrowSquareLeftIcon from "@assets/icons/arrowSquareLeft"
import NavigationsPage from "@containers/NavigationsPage/NavigationPage"
import PageWrapper from "@components/Common/PageWrapper"
import ProfileDetails from "@components/MyAccountPage/ProfileDetails"
import styles from "./MyAccountPage.module.css"
import InstituteDetails from "@components/MyAccountPage/InstituteDetails"
import LocationDetails from "@components/MyAccountPage/LocationDetails"
import OrbsWayPlans from "@components/MyAccountPage/OrbsWayPlans"
import MyPostPayments from "@components/MyAccountPage/MyPostPayments"
import { useSelector } from "react-redux"
import GoBack from "@components/Common/GoBack"
const MyAccountPage = () => {
  const { ownDetails } = useSelector((state) => {
    return state.profile
  })
  const { isViewable } = ownDetails?.access?.visionPostpaid || {}

  return (
    <NavigationsPage>
      <PageWrapper className={styles.myAccountPage}>
        <div className="flex flex-col gap-5 md:gap-10">
          <div className="flex md:gap-2 flex-col">
            <GoBack className="mb-4 md:hidden">
              <ArrowSquareLeftIcon />
            </GoBack>
            <h1 className="text-sm md:text-2xl 3xl:text-4xl uppercase md:normal-case font-bold text-[--primary-blue] md:text-[--quaternary-black] md:font-normal">
              My Account
            </h1>
            <p className="hidden md:block text-base 3xl:text-xl font-semibold text-[--text-light-gray]">
              One Place Solution for all your needs, Try other An overview of
              account details
            </p>
          </div>

          <div className="flex flex-col 3xl:flex-row gap-4 max-w-[1480px] items-start">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 w-full max-w-[984px]">
              <ProfileDetails data={ownDetails} />
              <InstituteDetails data={ownDetails} />
              <LocationDetails data={ownDetails} />
              <OrbsWayPlans data={ownDetails} />
            </div>
            {isViewable ? <MyPostPayments data={ownDetails} /> : null}
          </div>
        </div>
      </PageWrapper>
    </NavigationsPage>
  )
}

export default MyAccountPage
